export default { 
  privacyRouteWhitelist: ["/login", "/help", "/discover", "/dsico"]
}